export const COURSE_TYPE_BANNER = '1';//banner
export const COURSE_TYPE_DESC = '2';//description


export const COURSE_META_TEXT = 'text';
export const COURSE_META_IMG = 'image';
export const COURSE_META_VIDEO = 'video';


//0待付款；1已付款；2已签到；3退款中；4交易完成；5交易关闭 ,
export const ORDER_STATUS = {
	'WAITPAY': '0',
	'PAY': '1',
	'SIGNED': '2',
	'REFUND': '3',
	'FINISH': '4',
	'CLOSE': '5'
};
export const ORDER_STATUS_MAP = {
	'0': '待付款',
	'1': '待消费',
	'2': '已签到',
	'3': '退款中',
	'4': '交易完成',
	'5': '交易关闭'
};
export const COMMENT_TYPE = {
	NICE: '3',
	MIDDLE: '2',
	BAD: '1'
}




// WEBPACK FOOTER //
// ./src/assets/js/Constants.js